import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { FriendModelResponse } from './api.friend.model';

export class FriendApi {
  private apiUrl: string = environment.API_URL;
  FRIEND = '/friend';

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getFriend(pageNum?: number, userId?: string): Observable<FriendModelResponse> {
    const url = userId
      ? `${this.apiUrl}${this.FRIEND}/friends?page=${pageNum}&specifiedUserId=${userId}`
      : `${this.apiUrl}${this.FRIEND}/friends?page=${pageNum}`;
    return this.http.get<FriendModelResponse>(url).pipe(
      timeout(this.config.responseTimeout),
      map(response => {
        return response;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }
}
